/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
import { msalInstance } from './index';
import { protectedResources } from './auth-config';
import { SilentRequest } from '@azure/msal-browser';

const getToken = async (scopes: string[]) => {
  const account = msalInstance.getActiveAccount();

  if (!account) {
    throw Error('No active account! Verify a user has been signed in and setActiveAccount has been called.');
  }

  const tokenRequest: SilentRequest = {
    account,
    scopes,
    redirectUri: '/redirect.html',
  };

  const tokenResponse = await msalInstance.acquireTokenSilent(tokenRequest);
  return tokenResponse.accessToken;
};

export const callStaffEndpoint = async (endpoint: string) => {
  const accessToken = await getToken(protectedResources.api.scopes);

  const headers = new Headers();
  const bearer = `Bearer ${accessToken}`;

  headers.append('Authorization', bearer);

  const options = {
    headers,
    method: 'POST',
  };

  let rawResult;

  try {
    const res = await fetch(endpoint, options);
    rawResult = await res.text();
    rawResult = `${res.status}:${rawResult}`;
  } catch (e) {
    rawResult = `ERROR: ${e}`;
  }

  return rawResult;
};
